import { createSlice } from "@reduxjs/toolkit";
import { number_format } from "../utils/utils";

export const agentsSlice = createSlice({
  name : 'agents',
  initialState: {
    logged: false,
    nombre: 'Emmanuel',
    initData : [],
    toastAlert: {
      show : false,
      message : '',
    },
    home: {
      section : 1,
      arrPorPagar: [],
      arrPagados: [],
      arrVencidos: [],
      arrRenovaciones: [],
      arrContrato: [],
      dataRecibo: [],
      showModalRecibos: false,
      showModalFiltros: false,
      isLoadingViewContrato : false,
      isLoadPanel: false,
      recibosSearch: '',
      customDate: false,
      fechaInicio: '',
      fechaFin: '',
      modalRecibo:{
        sectionRecibo: 2,
        modalEditarPrimas: false,
        modalEndoso: false,
        modalObservacion: false,
        modalModificarRecibo: false,
        modalFechaPago: false,
        modalVerEndoso: false,
        modalMarcarPago: false,
        isLoadingVerEndoso: false,
        dataPanel: [],
        isLoadPanel: false,
        numero_endoso: '',
        id_endoso: '',
        isLoadingConfirmacion: false,
        dataEndoso: [],
      }
    },
    directorio:{},
    nube: {},
    productividad: {},
    actividad: {},
    configuracion: {},
  },
  reducers: {
    loginSuccess: (state) => {
      state.logged = true
    },
    changeName: (state,data) => {
      state.nombre = data.payload
    },
    setInitData: (state,data) => {
      state.initData = data.payload
    },
    setStateHome: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        home: {...state.home, ...newData}
      }
    },
    setStateHomeRecibo: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        home: {
          ...state.home,
          modalRecibo: {
            ...state.home.modalRecibo,
            ...newData
          }
        }
      }
    },
    updatePrimaNetaRecibo: (state,action) => {
      let { payload } = action;
      let { section, poliza, primaNeta } = payload;
      const newArray = state.home[section].map( element => {
        if(element.numero_poliza===poliza){
          element.prima_neta = primaNeta;
        }
        return element;
      })
      state.home[section] = newArray;
      state.home.arrContrato.configuracion.prima_neta = number_format(primaNeta);
    },
    updateStatusRecibo: (state,action) => {
      const { payload } = action;
      const { id_historial,status } = payload;
      const newArray = state.home.arrContrato.contratos.map( element => {
        if(element.id_historial==id_historial){
          element.estado  = status;
        }
        return element;
      });
      state.home.arrContrato.contratos = newArray;
    },
    updateStatusEndoso: (state,action) => {
      let { payload } = action;
      let { id_historial,status,id_cobro } = payload;
      const newArray = state.home.arrContrato.contratos.map( element => {
        if(element.id_historial==id_historial){
          element.endosos.map( endoso => {
            if(endoso.id_cobro==id_cobro){
              endoso.status = status;
            }
            return endoso;
          })
        }
        return element;
      });
      state.home.arrContrato.contratos = newArray;
    },
    marcarPagoRecibo: (state,action) => {
      const { payload } = action;
      const { section, poliza } = payload;
      return {
        ...state,
        home: {
          ...state.home,
          [section]: [...state.home[section].filter( element => {
            if(element.numero_poliza!==poliza){
              return element
            } 
          })]
        }
      }
    },
    quitarPagoRecibo: (state,action) => {
      const { payload } = action;
      const { section, poliza } = payload;
      return {
        ...state,
        home: {
          ...state.home,
          [section]: [...state.home[section].filter( element => {
            if(element.numero_poliza!==poliza){
              return element
            } 
          })]
        }
      }
    },
    updateContrato: (state,action) => {
      const { payload } = action;
      const { contratos, configuracion,nube } = payload;
      if(typeof contratos !== 'undefined'){
        if(contratos!==''){
          state.home.arrContrato.contratos = contratos;
        }
      }
      if(typeof configuracion !== 'undefined'){
        if(configuracion!==''){
          state.home.arrContrato.configuracion = configuracion;
        }
      }
      if(typeof nube !== 'undefined'){
        if(nube!==''){
          state.home.arrContrato.nube = nube;
        }
      }
    },
    updateContratoObservaciones: (state,action) => {
      const { payload } = action;
      const { observacion } = payload;
      state.home.arrContrato.configuracion.observacion = observacion;
    },
    actualizarEndoso: (state,action) => {
      const { payload } = action;
      const newArray =  {...state.home.arrContrato,...payload};
      state.home.arrContrato = newArray;
    },
    showAlert: (state,action) => {
      const { payload } = action;
      const { show, message } = payload;
      state.toastAlert.show = show;
      state.toastAlert.message = message;
    },
    setStateDirectorio: (state,data) => {
      state.directorio = data.payload
    },
    setStateNube: (state,data) => {
      state.nube = data.payload
    },
    setStateProductividad: (state,data) => {
      state.productividad = data.payload
    },
    setStateActividad: (state,data) => {
      state.actividad = data.payload
    },
    setStateConfiguracion: (state,data) => {
      state.configuracion = data.payload
    }
  }
})

export const { 
  loginSuccess, 
  changeName, 
  setInitData, 
  setStateHome,
  setStateHomeDataRecibo,
  setStateHomeRecibo,
  setStateDirectorio,
  setStateNube,
  setStateProductividad,
  setStateActividad,
  setStateConfiguracion,
  marcarPagoRecibo,
  quitarPagoRecibo,
  updatePrimaNetaRecibo,
  updateStatusRecibo,
  updateStatusEndoso,
  actualizarEndoso,
  showAlert,
  updateContrato,
  updateContratoObservaciones
} = agentsSlice.actions

export default agentsSlice.reducer